export const TEMPLATE_CONFIGS = {
    school: {
        labels: {
            student: 'Student',
            students: 'Students',
            class: 'Class',
            classes: 'Classes',
            teacher: 'Teacher',
            teachers: 'Teachers',
            marks: 'Marks',
            exams: 'Exams'
        }
    },
    kg: {
        labels: {
            student: 'Child',
            students: 'Children',
            class: 'Group',
            classes: 'Groups',
            teacher: 'Caregiver',
            teachers: 'Caregivers',
            marks: 'Progress',
            exams: 'Assessments'
        }
    },
    college: {
        labels: {
            student: 'Scholar',
            students: 'Scholars',
            class: 'Batch',
            classes: 'Batches',
            teacher: 'Professor',
            teachers: 'Professors',
            marks: 'Grades',
            exams: 'Semesters'
        }
    },
    high_school: {
        labels: {
            student: 'Student',
            students: 'Students',
            class: 'Grade',
            classes: 'Grades',
            teacher: 'Subject Teacher',
            teachers: 'Subject Teachers',
            marks: 'Marks',
            exams: 'Board Exams'
        }
    }
};

export const getTemplateLabel = (template, key, defaultLabel) => {
    const config = TEMPLATE_CONFIGS[template] || TEMPLATE_CONFIGS.school;
    return config.labels[key] || defaultLabel;
};
